$(document).on("click", ".question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').removeClass('active');
    jQuery('.question_product,.faq_question,.footer_menu_1 p, .footer_menu_2 p').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".custom_button", function() {
  var video = $(this).parents('.video_wrapper_custom').find('video').get(0); // Get native video element
  $(this).hide();
  $(this).parents('.video_wrapper_custom').addClass('video-active'); // Corrected class
  if (video) {
    video.play(); // Directly play video
  }
});
$(document).on("click", ".video_wrapper_custom video", function() {
  const video = $(this).get(0); // native DOM video element
  const wrapper = $(this).parents('.video_wrapper_custom');
  const playButton = wrapper.find('.custom_button');

  video.pause(); // actually pause
  playButton.show(); // show play button again
  wrapper.removeClass('video-active');
});

//  $(document).on("click", ".custom_button", function (e) {
//     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
//  if (jQuery(this).hasClass("active")) {
//     jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
//      jQuery(this).removeClass('active');
//  video.trigger('pause');
//  } else {
//  video.trigger('play');
//    jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
//      jQuery(this).addClass('active');
//  }
//  });







$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}
function getDecimalPlaces(value) {
  const str = value.toString();
  if (str.includes('.')) {
    return str.split('.')[1].length;
  }
  return 0;
}
$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.start_count .count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 2000,
        easing: 'swing',
        step: function (now) {                      
           $(this).text(parseFloat(now).toFixed(getDecimalPlaces($(this).data('value'))));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});





  $(window).scroll(function(){
      if ($(this).scrollTop() > 30) {
         $('body').addClass('remove_transparent');
      } else {
         $('body').removeClass('remove_transparent');
      }
  });








 






$(document).on("click", ".trigger_reviews_js_show", function (e) {
$('.review_with_text_landing_page_item.active').last().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
});



function updateCartCount() {
  $.getJSON('/cart.js', function(cart) {
    const itemCount = cart.item_count;
    $('cart-count.count-bubble').text(itemCount).css('opacity','1');
  });
}

// Function to refresh the <cart-drawer> via AJAX
async function refreshCartDrawer() {
 const response = await fetch(`${window.Shopify.routes.root}`);
  const text = await response.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  const newDrawer = doc.querySelector('#cart-drawer');

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && newDrawer) {
    cartDrawer.replaceChildren(...newDrawer.children);
  }
}

  

$(document).on("click", '.review_product_add', function(e) {
e.preventDefault(); 
var dataType = [];
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var quantity = 1;
var id = jQuery(this).attr('variant_id');
var data = {}; 
data['id'] = id;
 data['quantity'] = quantity; 
dataType.push(data);
  

  
const newData = {
items : [...dataType]
}

      // Step 2: Add items to cart
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(newData),
        contentType: 'application/json',
        dataType: 'json',
        success: function(response) {
     // Step 3: Refresh the cart drawer
        
           updateCartCount();
          //this_element.removeClass('loading_hk');
          setTimeout(function() {
              refreshCartDrawer();
              const cartDrawer = document.querySelector("#cart-drawer");
              cartDrawer.setAttribute("open", "");
              this_element.removeClass('loading_hk'); 
          }, 1500);
        },
        error: function(err) {
          console.error("Add to cart error", err);
        alert("Error adding items to cart. Please try again.");
          this_element.removeClass('loading_hk');
        }
      });
});












$(document).on("click", ".custom_popup_close,.custom_popup_bg", function (e) {
  e.preventDefault();
  $('.custom_popup').hide().css('opacity','0');
$('.custom_popup_middle_product_ietm.active').find('input').val('0');
$('.custom_popup_middle_product_ietm.active').find('.item_edit').hide();
$('.custom_popup_middle_product_ietm.active').find('.custom_popup_product_add').show();
$('.custom_popup_middle_product_ietm.active').removeClass('active');
$('.custom_popup_submit_button_final').hide(); 
$('.custom_popup_submit_button_initial').show(); 
$('.custom_popup').removeClass('max_full');
});

$(document).on("click", "a[href='#popup']", function (e) {
  e.preventDefault();
  $('.custom_popup').show().css('opacity','1');
});

$(document).on("click", ".custom_popup_product_add", function (e) {
$(this).parents('.custom_popup_middle_product_flex').find('.quantity_plus').trigger('click'); 
});


$(document).on("click", ".quantity_plus", function (e) {
  var input = $(this).parents(".label_quantity").find("input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value + 1);
  input.val(new_value);
  $('.quantity_minus').removeAttr('disabled'); 
  $(this).parents('.custom_popup_middle_product_flex').find('.custom_popup_product_add').hide(); 
  $(this).parents('.custom_popup_middle_product_ietm').addClass('active'); 
  $(this).parents('.item_edit').show(); 
  var max_quantity = parseInt($('.quantity_item.active').attr('data_tab'));
  var current_quantity = 0;
  $('.custom_popup_middle_product_ietm.active input').each(function(){
  var quantity_loop =  parseInt($(this).val());
  current_quantity = current_quantity + quantity_loop;
  });

  console.log("Active Pack Quantity Limit:", max_quantity);
  
  if (max_quantity === 1) {
    if (current_quantity === 1) {
      $('.custom_popup_submit_button_final').show(); 
      $('.custom_popup .continue_adding_button').show(); 
        $('.custom_popup_submit_button_final').show(); 
      $('.custom_popup_submit_button_initial').hide(); 
       $('.quantity_frage').text('1');
    } 
    else if (current_quantity === 2) {
      $('.free_products_lp_flex_item').addClass('active'); 
      $('.scents').text('BOTTLE');
      $('.quantity_frage').text('4');
      $('.locked_div').hide();
      $('.unlocked_div').show();
    } 
  }

  
  var quantity_remain = max_quantity - current_quantity;
  $('.quantity_frag').text(quantity_remain);
  if (quantity_remain == 1){
   $('.initial_1').show(); 
   $('.initial_2').hide(); 
  } else {
   $('.initial_1').hide(); 
   $('.initial_2').show(); 
  }
  if (max_quantity === 1) {
    if (current_quantity == 3){
      $('.custom_popup').addClass('max_full');
      $('.custom_popup_submit_button_final').show(); 
      $('.custom_popup_submit_button_initial').hide(); 
    } else {
      $('.custom_popup').removeClass('max_full');
    }
  }
    
  else{
     if (current_quantity == max_quantity){
      $('.custom_popup').addClass('max_full');
      $('.custom_popup_submit_button_final').show(); 
      $('.custom_popup_submit_button_initial').hide(); 
    } else {
      $('.custom_popup').removeClass('max_full');
    }
  }
});


$(document).on("click", ".quantity_minus", function (e) {
  var input = $(this).parents(".label_quantity").find("input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value - 1);

  if (new_value <= 0) {
    new_value = 0;
    $(this).attr('disabled', 'disabled'); // disable minus if value is 0
    $(this).parents('.custom_popup_middle_product_ietm').removeClass('active');
    $(this).parents('.custom_popup_middle_product_flex').find('.custom_popup_product_add').show();
    $(this).parents('.item_edit').hide();
  }

  input.val(new_value);

  var max_quantity = parseInt($('.quantity_item.active').attr('data_tab'));
  var current_quantity = 0;

  $('.custom_popup_middle_product_ietm.active input').each(function () {
    var quantity_loop = parseInt($(this).val());
    current_quantity += quantity_loop;
  });

  var quantity_remain = max_quantity - current_quantity;
  if (max_quantity !== 1) {
    $('.quantity_frag').text(quantity_remain);
  }
  if (quantity_remain == 1) {
    $('.initial_1').show();
    $('.initial_2').hide();
  } else {
    $('.initial_1').hide();
    $('.initial_2').show();
  }

  if (max_quantity === 1) {
       if (current_quantity == 0) {
          $('.custom_popup').removeClass('max_full');
          $('.custom_popup_submit_button_final').hide();
          $('.custom_popup_submit_button_initial').show();
          $('.initial_1 .custom_popup_submit_button').text("SELECT AT LEAST 1 BOTTLE");
          $('.quantity_frage').text("1");
       }
      else if (current_quantity === 1) {
           $('.quantity_frage').text('1');
        } 
    else {
         $('.custom_popup').removeClass('max_full');
        $('.custom_popup_submit_button_final').show();
        $('.custom_popup_submit_button_initial').hide();
      }
    }
    
  else{
    if (current_quantity == max_quantity) {
     $('.custom_popup').removeClass('max_full');
      $('.custom_popup_submit_button_final').show();
      $('.custom_popup_submit_button_initial').hide();
      } else {
       $('.custom_popup').removeClass('max_full');
      $('.custom_popup_submit_button_final').hide();
      $('.custom_popup_submit_button_initial').show();
    }
  } 
  

   if (max_quantity === 1) {
      if (current_quantity < 2) {
        $('.free_products_lp_flex_item').removeClass('active');
         $('.free_products_lp_flex_item[data_tab="1"]').addClass('active'); 
        $('.locked_div').show();
        $('.unlocked_div').hide();
        $('.scents').text('BOTTLE');
        // $('.quantity_frage').text(current_quantity + 1);
      }
   }
});

$(document).ready(function () {
  $(".txt_rev-wrapper").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  });
});

$(document).ready(function () {
  $(".frag_card_slider").slick({
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    arrows: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});
